import React from 'react';
import _ from 'lodash';
import { DateInput } from '../DateInput';
import { deleteControlCode } from '../../utilities/stringUtil';
import AttachDocument from '../forms/AttachDocument';
import {
  FormListItemGroup,
  FormListItemChild,
  FormElement,
} from '../CommonFormComponents';
import ComboBox from '../combobox/ComboBox';

const SelectDateBlock = ({
  targetValues,
  comboBoxList,
  keyParams,
  labelName,
  labelDate,
  events,
  disabledAll,
  showInput = null,
  messages,
  safetyDocItem = false,
  attachDocumentParams,
}) => {
  const { searchKey, targetKey, dateKey } = keyParams;
  return _.map(targetValues, (value, index) => {
    const message = _.get(messages, `[${index}].${searchKey}`);
    const messageInput =
      showInput && _.get(messages, `[${index}].${showInput.name}`);
    const messageDateInput = _.get(messages, `[${index}].${dateKey}`);
    const isPreview = disabledAll === true;
    return (
      <FormListItemGroup
        closeFn={
          isPreview
            ? false
            : () => {
                events.deleteValue([...targetValues], index, keyParams);
              }
        }
        key={index}
        isBorder={false}
      >
        <FormListItemChild label={labelName} safetyDocItem={safetyDocItem}>
          <FormElement validate={message}>
            <div
              className={`form-list__element-select ${
                disabledAll ? 'form-list__element-select--disabled' : ''
              }`}
            >
              <ComboBox
                listId={`${targetKey}-list`}
                disabled={disabledAll}
                value={value[searchKey]}
                comboBoxList={comboBoxList}
                comboBoxValueKey={searchKey}
                onChange={e => {
                  events.inputValueSearch(
                    [...targetValues],
                    comboBoxList,
                    deleteControlCode(e.target.value),
                    index,
                    keyParams
                  );
                }}
              />
            </div>
          </FormElement>
        </FormListItemChild>

        {showInput && (
          <FormListItemChild label={showInput.labelInput}>
            <FormElement validate={messageInput}>
              {disabledAll ? (
                <span>{targetValues[index][showInput.name]}</span>
              ) : (
                <input
                  id={showInput.name}
                  type='text'
                  name={showInput.name}
                  value={targetValues[index][showInput.name] || ''}
                  onChange={e => {
                    const clonedValues = _.cloneDeep(targetValues);
                    clonedValues[index] = {
                      ...clonedValues[index],
                      [e.target.name]: deleteControlCode(e.target.value),
                    };
                    events.setJobValues(
                      [targetKey],
                      clonedValues,
                      keyParams.blockKey
                    );
                  }}
                  disabled={disabledAll}
                />
              )}
            </FormElement>
          </FormListItemChild>
        )}

        <FormListItemChild label={labelDate}>
          {disabledAll && !targetValues[index][dateKey] ? null : (
            <DateInput
              isPreview={isPreview}
              dateString={targetValues[index][dateKey]}
              disabled={disabledAll}
              onChangeValue={val => {
                const clonedValues = _.cloneDeep(targetValues);
                clonedValues[index][dateKey] = val;
                events.setJobValues(
                  [targetKey],
                  clonedValues,
                  keyParams.blockKey
                );
              }}
              message={messageDateInput}
              jpDelimiterChar={true}
            />
          )}
        </FormListItemChild>
        {attachDocumentParams && (
          <FormListItemChild label={attachDocumentParams.labelDocument}>
            <FormElement>
              <AttachDocument
                companyDocuments={targetValues[index].worker_documents}
                documentCodes={attachDocumentParams.documentCodes}
                events={events}
                readOnly={disabledAll}
                itemName={attachDocumentParams.itemName}
                indexId={attachDocumentParams.indexId}
                isFormListDefault={true}
                index={index}
                keyName={attachDocumentParams.keyName}
              />
            </FormElement>
          </FormListItemChild>
        )}
      </FormListItemGroup>
    );
  });
};

export default SelectDateBlock;



// WEBPACK FOOTER //
// ./src/components/worker/SelectDateBlock.jsx